// hooks/useNovaAiModalHeader.js
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import useApplicationTracker from "customHooks/useApplicationTracker";
import {
  setIsNovaChatBotOpen,
  setNewConversation,
} from "store/AiFeatures/GoalsCreateWithNovaAI/action";
import { ChatwootAPI } from "Tracking";
import { APP_ENV } from "config/api-config";

const useNovaAiModalHeader = ({ renameConversation }) => {
  const dispatch = useDispatch();
  const { captureUserEvent } = useApplicationTracker();
  const { accountId, employeeId } = useSelector((state) => state.user);
  const newConversationTitle = useSelector(
    (state) => state?.aiFeatures?.goalsCreateWithNovaAI.conversation?.name
  );
  const data = JSON.parse(
    localStorage.getItem("nova_conversation_data") || "{}"
  );
  const storedTitle = data[employeeId]?.title;
  const conversationTitle = newConversationTitle || storedTitle;

  const [isEditing, setIsEditing] = useState(false);
  const [tempTitle, setTempTitle] = useState(conversationTitle);
  const [hovered, setHovered] = useState(false);
  const inputRef = useRef(null);

  const isAppEnvProdOrDemo = [
    "PRODUCTION",
    "DEMO",
    "LOCALHOST",
    "EPSILON",
  ].includes(APP_ENV);

  const superAdminToken = window.localStorage.getItem("super_admin_token");
  const impersonatorAuthToken = window.localStorage.getItem(
    "impersonator_auth_token"
  );

  const handleCloseIconClick = () => {
    dispatch(setIsNovaChatBotOpen(false));
  };

  const handleRename = () => {
    if (tempTitle && tempTitle.trim() && tempTitle !== conversationTitle) {
      renameConversation(tempTitle.trim());
    }
    setIsEditing(false);
  };

  const handleRenameByPress = (e) => {
    if (e.key === "Enter") {
      handleRename();
    } else if (e.key === "Escape") {
      setTempTitle(conversationTitle);
      setIsEditing(false);
    }
  };

  const createNewConvo = () => {
    dispatch(setNewConversation(true));
    captureUserEvent("nova_new_conversation_icon_clicked", {
      accountId: accountId,
    });
  };

  const openChatWoot = () => {
    if (isAppEnvProdOrDemo) {
      const { init } = ChatwootAPI();
      if (superAdminToken || impersonatorAuthToken) return;
      init();
    }
    dispatch(setIsNovaChatBotOpen(false));
    captureUserEvent("nova_peoplebox_support_click_from_nova_ui", {
      accountId: accountId,
    });
  };

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  useEffect(() => {
    if (conversationTitle) {
      setTempTitle(conversationTitle);
    }
  }, [conversationTitle]);

  return {
    novaHeaderProps: {
      inputRef,
      hovered,
      setHovered,
      isEditing,
      setIsEditing,
      tempTitle,
      setTempTitle,
      handleRename,
      handleRenameByPress,
      createNewConvo,
      openChatWoot,
      handleCloseIconClick,
      conversationTitle,
    },
  };
};

export default useNovaAiModalHeader;
